import React from "react";

export const IconsComponentsFacebook = ({ fill }) => {
  return (
    <svg
      width="51"
      height="50"
      viewBox="0 0 51 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.9131 25.0011V25C48.9131 12.1331 38.4462 1.66667 25.5801 1.66667C12.7139 1.66667 2.24705 12.1331 2.24705 25C2.24705 37.8669 12.7139 48.3333 25.5801 48.3333C38.4473 48.3333 48.9216 37.8661 48.9131 25.0011ZM0.580078 25C0.580078 38.7871 11.793 50 25.5801 50C39.3672 50 50.5892 38.7871 50.5801 25C50.5801 11.2129 39.3672 0 25.5801 0C11.793 0 0.580078 11.2129 0.580078 25Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.583 25.3112V35.719C23.583 35.8704 23.7014 35.9888 23.8528 35.9888H27.7153C27.8667 35.9888 27.9851 35.8704 27.9851 35.719V25.1401H30.7883C30.9265 25.1401 31.0449 25.0348 31.0581 24.8901L31.3278 21.7059C31.341 21.548 31.216 21.4099 31.0581 21.4099H27.9851V19.1467C27.9851 18.6138 28.4128 18.1862 28.9458 18.1862H31.1041C31.2555 18.1862 31.3739 18.0678 31.3739 17.9164V14.7322C31.3739 14.5809 31.2555 14.4625 31.1041 14.4625H27.4521C25.3136 14.4625 23.5764 16.1993 23.5764 18.3375V21.4099H21.6419C21.4905 21.4099 21.3721 21.5283 21.3721 21.6796V24.8638C21.3721 25.0151 21.4905 25.1335 21.6419 25.1335H23.5764V25.3112H23.583Z"
        fill={fill}
      />
    </svg>
  );
};
